<template>
  <div class="videoMaterial">
    <el-card>
      <div>
        <el-row :gutter="20">
          <el-col :sm="24" :md="16" :lg="16">
            <span>选择视频</span>
            <el-button style="margin-left:20px;" type="primary" plain @click="selectVideoVisibleBlock = true,selectVideoVisible = true">选择视频</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row :gutter="20">
          <el-col :sm="24" :md="16" :lg="16">
            <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="videoList" tooltip-effect="dark" style="margin-top: 20px;margin-left:70px;" border @selection-change="selectionVideoChange">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="name" label="视频" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div style="display:flex;justify-content:space-between">
                    <el-input v-if="scope.row.editBlock" size="small" v-model="scope.row.name" style="width:200px">
                      <span class="operation-style" style="line-height:35px" slot="suffix" @click="updateVideoInfoByAttachmentList(scope.row)">保存</span>
                      <span style="line-height:35px;margin-left:10px" slot="suffix" @click="editBlockCancel(scope.row)">取消</span>
                    </el-input>
                    <div v-else>{{scope.row.name}}</div>
                    <i style="line-height:22.4px" class="operation-style el-icon-edit" @click="editBlockClick(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="大小" width="120">
                <template slot-scope="scope">{{(scope.row.size/1024/1024).toFixed(4)}}MB</template>
              </el-table-column>
              <el-table-column prop label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <div class="operationGroup">
                    <span class="operation-style" @click="deleteVideo(scope.row)">移除</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="16" :lg="16">
            <div style="margin-top: 20px;margin-left:70px;">
              <el-button @click="videoList = []">重 置</el-button>
              <el-button type="primary" @click="bindTencent">提 交</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-dialog title="选择视频" :visible.sync="selectVideoVisible" width="800px" left>
        <videoMaterial @videoListChange="changeVideoList" v-if="selectVideoVisibleBlock"></videoMaterial>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import videoMaterial from "../common/videoMaterial";
export default {
  components: { videoMaterial },
  data () {
    return {
      loading: false,
      selectVideoVisible: false,
      selectVideoVisibleBlock: false,
      videoList: [],
      ids: []
    };
  },
  computed: {},
  methods: {
    bindTencent () {
      console.log(this.bindTencentBlock)
      // debugger
      if (this.bindTencentBlock) {
        return;
      }
      if (this.ids.length == 0) {
        this.$message.error("请选择需要绑定的视频！");
        return;
      }
      this.bindTencentBlock = true;
      let obj = {
        attachmentList: [],
        videoCourseId: this.$route.query.id
      };
      this.ids.forEach(e => {
        obj.attachmentList.push({ objectId: e.objectId })
      })
      this.api.videoInfo.bindTencent(obj).then(result => {
        if (result.success) {
          this.bindTencentBlock = false;
          // this.$router.push({path:"/videoCourse"});
          this.$router.go(-1)
        } else {
          this.$message.error(result.message || '系统异常')
        }
      });
    },
    updateVideoInfoByAttachmentList (row) {
      this.api.videoInfo.updateVideoInfoByAttachmentList(row).then(result => {
        if (result.success) {
          this.$set(row, 'editBlock', false)
        }
      })
    },
    editBlockClick (row) {
      console.log("row", row)
      this.$set(row, 'editBlock', true)
    },
    editBlockCancel (row) {
      this.$set(row, 'editBlock', false)
    },
    deleteVideo (row) {
      this.$confirm("将会删除该视频，是否确认删除？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.videoList.forEach((e, index) => {
          if (e.id == row.id) {
            this.videoList.splice(index, 1);
          }
        });
      });
    },
    changeVideoList (ids) {
      this.videoList = ids;
      this.videoList.forEach(e => {
        this.$set(e, 'editBlock', false)
      })
      this.selectVideoVisible = false;
      this.selectVideoVisibleBlock = false;
    },
    selectionVideoChange (val) {
      this.ids = val;
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/videoCourse/addVideo.vue